"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "10", height: "1", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { stroke: "#1F1F1F", strokeLinecap: "round", d: "M.5.5h9" }))); };
exports.default = Component;
//# sourceMappingURL=Minus.js.map